import axiosInstance from 'api/axiosInstance';
import { Ticket } from 'containers/pages/CANpark/types/ticket';

const VEHICLE_INFO_FALLBACK = 'Not Provided';

export interface AddTicketRequest extends Omit<Ticket, 'issuedBy'> {
	issuerUserId: string; // Only exists when adding a ticket
}

export const addTicket = async (ticket: AddTicketRequest): Promise<Ticket> => {
	try {
		const API_URL = `/api2.0/tickets/addTicket`;
		const trimmedVehicleInfo = ticket.vehicleInfo?.trim();
		const response = await axiosInstance.post<Ticket>(
			API_URL,
			{
				ticketNumber: ticket.ticketNumber,
				ticketType: ticket.ticketType,
				parkingLocationId: ticket.parkingLocationId,
				parkingZone: ticket.parkingZone,
				licenseNumber: ticket.licenseNumber,
				licenseState: ticket.licenseState,
				vehicleInfo: trimmedVehicleInfo || VEHICLE_INFO_FALLBACK,
				issuerUserId: ticket.issuerUserId, // Pass userId when adding
				comments: ticket.comments || '',
				date: ticket.date.toISOString(),
				attachmentIds:
					ticket.attachments.map(
						(attachment) => attachment.AttachmentID,
					) || [],
			},
			{
				headers: {
					'Content-Type': 'application/json',
				},
			},
		);

		return response.data;
	} catch (error) {
		console.error('Error adding ticket:', error);
		throw error;
	}
};
